import FormControlLabel from '@mui/material/FormControlLabel';
import React, {FC} from 'react';
import {SxType} from "@baseTypes/sx/sxTypes";
import Checkbox from '@mui/material/Checkbox';
import {sx} from './sx'

interface IProps {
    disabled?: boolean,
    checked?: boolean,
    onChange?: (checked: boolean) => void,
    label?: string,
    labelPlacement?: "bottom" | "top" | "end" | "start",
    sx?: SxType,
    tooltip?: string,
    convertToBoolean?: boolean,
    size?: 'small'
}

const CheckboxCustom: FC<IProps> = ({
                                        checked,
                                        onChange,
                                        convertToBoolean,
                                        label,
                                        labelPlacement,
                                        size,
                                        disabled,
                                    }) => {

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = convertToBoolean ? event.target.checked ? 1 : 0 : event.target.checked as boolean;
        if (onChange) {
            onChange(checked as boolean)
        }
    }
    return (
        <FormControlLabel
            labelPlacement={labelPlacement}
            sx={sx.root}
            control={
                <Checkbox
                    disabled={disabled}
                    sx={sx.checkbox}
                    checked={checked}
                    onChange={handleChange}
                    size={size}
                />}
            label={label}

        />
    );
};

export default CheckboxCustom;